import {hasPermission, PERMISSIONS as P} from "../auth/permissions";
import {normalizeRoles, ROLES} from "../auth/roles";

export const defaultAppRoute = session => {
  const permissions = session?.permissions || [];
  const roles = normalizeRoles(session?.roles);

  if (hasPermission(permissions, P.DASHBOARD_VIEW)) return "/app/dashboard";
  if (!roles.includes(ROLES.MINION)) return "/app/account";
  if (hasPermission(permissions, P.SELF_RESOURCES)) return "/app/employee-panel";
  if (hasPermission(permissions, P.KNOWLEDGE_BASE_VIEW)) return "/app/knowledge-base";
  return "/unauthorized";
};
